import { useContext } from 'react';
import { OneHeaderContext } from '../common/providers/OneHeaderProvider';
import { ConfigurationsState } from 'Common/appshell_types/remoteConfigType';

const useOneHeaderContext = () => {
    const context = useContext<ConfigurationsState>(OneHeaderContext);

    if (!context) {
        throw new Error('useOneHeaderContext must be used within the ConfigProvider');
    }

    return context;
};

export default useOneHeaderContext;
